module.exports = __webpack_public_path__ + "img/benadvance.bc2f477e.jpg";